import React from "react";
import { useTheme } from "../context/ThemeContext";

function About() {
  const { theme } = useTheme();

  return (
    <div className="container mx-auto my-8 px-4">
      <h2
        className={`text-5xl md:text-6xl font-light mb-6 ${theme.text} font-handwriting`}
      >
        Über mich – Wer ich bin und was mich antreibt
      </h2>

      <div className="grid md:grid-cols-2 gap-12 items-start mb-12">
        <div className="space-y-6">
          <p className="text-lg leading-relaxed text-slate-700">
            Mein Name ist Lisa Fuchsen. Ich lebe mit meinem Mann, unserem
            Hund und zeitweise mit meinen zwei Bonuskindern in Wittlich. Mein
            beruflicher Weg hat mich über mein Studium der Sozialen Arbeit in
            Stuttgart zu verschiedenen Tätigkeiten in der Jugendhilfe und
            Frauenberatung geführt – sowohl in der direkten Arbeit mit Menschen
            als auch in leitender Funktion.
          </p>
          <p className="text-lg leading-relaxed text-slate-700">
            Neben meiner langjährigen Erfahrung in der sozialen Arbeit habe ich
            mich intensiv mit systemischer Beratung und
            Persönlichkeitsentwicklung beschäftigt. Ich bin zertifizierte
            Systemische Beraterin (SG) und Meditationslehrerin. In meiner Arbeit
            verbinde ich systemische Methoden mit einem ganzheitlichen Blick auf
            das Leben: Ich bin davon überzeugt, dass Herausforderungen nicht
            zufällig entstehen, sondern immer eine Entwicklungschance in sich
            tragen.
          </p>
          <p className="text-lg leading-relaxed text-slate-700">
            Meine Haltung ist ressourcenorientiert und geprägt von der
            Überzeugung, dass das Leben für uns arbeitet – auch wenn es sich
            manchmal anders anfühlt. Jeder Mensch trägt bereits alle Fähigkeiten
            in sich, um seinen Weg zu gehen. Manchmal braucht es nur einen neuen
            Blickwinkel, eine bewusste Entscheidung zur Veränderung oder
            jemanden, der beim inneren Sortieren unterstützt. Genau das ist
            meine Leidenschaft: Menschen zu verstehen, Muster zu erkennen,
            Klarheit zu schaffen und sie dabei zu begleiten, ihre eigenen
            Lösungen zu finden.
          </p>
        </div>

        <div className="flex justify-center">
          <img
            src="/images/lisaporträt.jpg"
            alt="Lisa Fuchsen"
            className="w-full max-w-md rounded-lg shadow-lg"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className={`${theme.box} p-8 rounded-lg shadow-lg`}>
          <h3 className="text-2xl font-semibold mb-6 text-slate-800">
            Qualifikation
          </h3>
          <ul className="space-y-3 text-lg text-slate-700">
            <li>• Sozialpädagogin (DHBW Stuttgart)</li>
            <li>• Zertifizierte Systemische Beraterin (SG)</li>
            <li>• Meditationslehrerin</li>
            <li>• Gastdozentin in der DHBW Stuttgart</li>
            <li>• Langjährige Berufserfahrung in der:</li>
            <ul className="ml-6 space-y-2 mt-2">
              <li>- Erziehungs- und Lebensberatung</li>
              <li>- Krisenberatung</li>
              <li>- Kinder- und Jugendhilfe</li>
            </ul>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default About;
